<script setup lang="ts">
import type { AvatarRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { AvatarRoot, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<AvatarRootProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <AvatarRoot
        data-slot="avatar"
        v-bind="forwardedProps"
        :class="cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', props.class)"
    >
        <slot />
    </AvatarRoot>
</template>
